import { useSelector, shallowEqual } from 'react-redux';

import { toNucleusAddress } from 'utils/nucAddressFormat';
import {
  selectAddressList,
  selectErrors as selectAddressListErrors
} from 'state/address-list/address-list-slice';
import { selectErrors as selectInitiateErrors } from 'state/initiate/initiate-slice';
import { selectPostcode } from 'state/postcode/postcode-slice';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';

const { selectAPIErrors: meterTypeApiErrors } = meterTypeSelectors;

export const useNsxAddressSelector = () => {
  const postcode = useSelector(selectPostcode, shallowEqual);
  const addresses = useSelector(selectAddressList, shallowEqual);
  const nucAddresses = addresses?.map((address) => toNucleusAddress(address));

  // errors
  const initiateErrors = useSelector(selectInitiateErrors, shallowEqual) || [];
  const addressListErrors =
    useSelector(selectAddressListErrors, shallowEqual) || [];
  const meterTypeErrors = useSelector(meterTypeApiErrors, shallowEqual);

  const errors = [...initiateErrors, ...addressListErrors, ...meterTypeErrors];

  const noAddressFound = !!(addresses && !addresses.length);
  const isSingleAddress = addresses && addresses.length === 1;

  return {
    errors,
    postcode,
    nucAddresses,
    noAddressFound,
    isSingleAddress
  };
};
